import { useLanguage } from "@/context/LanguageContext";
import { Link, useSearchParams } from "react-router-dom";

const DonationSuccess = () => {
  const { copy } = useLanguage();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("order");

  return (
    <div className="donation-page" data-testid="donation-success-page">
      <div className="donation-card" data-testid="donation-success-card">
        <h1 className="section-title" data-testid="donation-success-title">
          {copy.donationFlow.successTitle}
        </h1>
        <p className="section-text" data-testid="donation-success-body">
          {copy.donationFlow.successBody}
        </p>
        {orderId ? (
          <p className="donation-order" data-testid="donation-order-id">
            {copy.donationFlow.orderLabel}: {orderId}
          </p>
        ) : null}
        <Link to="/" className="primary-button" data-testid="donation-success-home">
          {copy.donationFlow.backHome}
        </Link>
      </div>
    </div>
  );
};

export default DonationSuccess;
